module.exports = __webpack_public_path__ + "img/footer-cyber-security.cee4556f.png";